import axios from "axios";

const getIlListesi = async (baseUrl) => {

    /*const config = {
        headers: { Authorization: `Bearer ${token}` }
    };*/

    let getResponse = null

    await axios.get(baseUrl + `/Common/city`)
        .then((res) => {
            getResponse = {
                status: res.status,
                result: res.data.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                getResponse = {
                    status: error.response.status,
                    result:  error.response.status
                }
            }
        });
    return getResponse
}

export default getIlListesi;